import app from '../app';

const { $html,$header } = app.el;
let ticking = false;

function onScroll() {
  $html[0].style.setProperty('--scroll-y', `${window.scrollY}px`);
  ticking = false;
  if(window.scrollY > 0) {
    $header.addClass('scrolled')
  } else {
    if(!document.body.classList.contains('open-search')) {
      $header.removeClass('scrolled')
    }
  }
}

document.onscroll = () => {
  if (!ticking) {
    requestAnimationFrame(onScroll);
    ticking = true;
  }
};
